import { ampFetch } from '../fetch.js'

export default async function getCss(uri) {
  const response = await ampFetch(uri)

  return response.text()
}
